<template>
  <v-flex v-bind="{ [`md${ rowIndex === 0 ? 12 : 12 - boxSize + 1}`]: true }" >
    <v-layout v-bind="{ [`md${boxSize - 1}`]: rowIndex < data.length - 1 }" row wrap class="bordered-bottom">
      <template v-if="data[rowIndex]">
        <v-flex v-bind="{ [`md${boxSize}`]: true }" >
          <span class="break-word">
            {{ data[rowIndex].label }}
          </span>
        </v-flex>
        <pivot-header
          :data="data"
          :row-index="rowIndex + 1">
        </pivot-header>
      </template>
    </v-layout>
  </v-flex>
</template>
<script>
  import PivotHeader from './PivotHeader';

  export default {
    name: 'pivot-header',
    props: {
      data: {
        type: Array,
        default: () => [],
      },
      rowIndex: {
        type: Number,
        default: 0,
      },
    },
    components: {
      PivotHeader,
    },
    computed: {
      boxSize() {
        return Math.floor(12 / this.data.length) + this.rowIndex;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/global/report_datatables/PivotHeader.vue